import React, { useState, useEffect } from "react";
import Image from '../../images/preview.gif';
import useInterval from "../Scripts/useInterval";
import { bigNumAsInt } from "../Scripts/bigNumAsInt";
import { ethers } from "ethers";
import { useMetamask } from "../Scripts/UseMetamask";
import GeneralMint from "../Scripts/GeneralMint";
import WhitelistMint from "../Scripts/WhitelistMint";

import Contract from "../contracts/bitgoblin.abi.json";

import is from "ramda/src/is";
import {
  HeroContainer,
  HeroBg,
  HeroContent,
  ImageBg,
  PreviewImage,
  UserWrapper,
  HeroH1,
  HeroP,
  HeroP2,
  HeroP3
} from "./HeroElements";

const contractAddress = "0x0BA97462E86Af0F87Dd15E1E14FcEB687026e0C6";

function HeroSection() {
  const [hover, setHover] = useState(false);
  const [totalMinted, setTotalMinted] = useState(0);
  const [isMintOpen, setIsMintOpen] = useState(false);
  const [isWhitelistMint, setWhitelistMint] = useState(false);

  const { account, provider } = useMetamask();

  const handleFetchIsMintOpen = async () => {
    const contract = new ethers.Contract(
      contractAddress,
      Contract.abi,
      provider
    );

    try {
      const isMintOpen = await contract._openMint();
      setIsMintOpen(isMintOpen);
    } catch (err) {
      console.log(err);
    }
  };

  const handleFetchIsWhitelistOpen = async () => {
    const contract = new ethers.Contract(
      contractAddress,
      Contract.abi,
      provider
    );

    try {
      const isWhitelistMint = await contract._onlyWhitelisted();
      setWhitelistMint(isWhitelistMint);
    } catch (err) {
      console.log(err);
    }
  };

  const handleFetchTotalMinted = async () => {
    const contract = new ethers.Contract(
      contractAddress,
      Contract.abi,
      provider
    );

    try {
      const totalMinted = await contract.totalSupply();
      setTotalMinted(bigNumAsInt(totalMinted));
    } catch (err) {
      console.log(err);
    }
  };
  
  useInterval(() => {
    handleFetchIsWhitelistOpen();
  }, 5000);

  useInterval(() => {
    handleFetchIsMintOpen();
  }, 5000);

  useInterval(() => {
    handleFetchTotalMinted();
  }, 5000);

  const onHover = () => {
    setHover(!hover);
  };
  return (
    <HeroContainer>
      <HeroContent id="mint">
        <ImageBg>
          <PreviewImage src={Image} width="300px" height="300px" image-radius="50px" />
        </ImageBg>
        <UserWrapper>
          <HeroH1>FILFY HOOMAN!</HeroH1>
          <HeroP2>
          Phloor is one fousand!
          </HeroP2>
          <HeroP2>
            2469/2469
          </HeroP2>
            <HeroP2>MINTED OUT!</HeroP2>

          <HeroP3>
            Plz be kunnekted to FTM network
          </HeroP3>
        </UserWrapper>
      </HeroContent>
    </HeroContainer>
  );
}

export default HeroSection;
